import { fallback, InferOutput, literal, object } from 'valibot'
import { ArmorSchema } from '../../Armor.type'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { entityTypeDefaults, EntityTypeMeta } from '../../EntityTypeMeta'
import { FuelSchema } from '../../fuel.type'
import { HasMobilitySchema } from '../../has_mobility'
import { HasXYSchema } from '../../has_xy'
import { HPSchema } from '../../hp.type'
import { PlayerIdOrNullSchema } from '../../player/PlayerIdOrNull'
import { VisionSchema } from '../../vision.type'
import { WasBuiltThisTurnSchema } from '../../WasBuiltThisTurn'
import { ArmorTypeId } from '../Armor/ArmorTypeId.enum'
import { BaseEntitySchema } from '../BaseEntity'
import { EntityIdSchema } from '../EntityId.type'
import { EntityIdListSchema } from '../EntityIdList.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'
import { MoveTypeId } from '../move_type_id.enum'

const entDefaults = {
  etype_id: EntityTypeId.TransportCopter,
  layer_id: EntityLayerId.Unit2,
  hp: 10,
  fuel: 99,
  vision: 2,
  mtype_id: MoveTypeId.Helicopter,
  mobility: 6,
  armor: 5,
} as const

export const TransportCopterEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.TransportCopter),
  layer_id: literal(EntityLayerId.Unit2),
  id: EntityIdSchema,
  player_id: PlayerIdOrNullSchema,
  hp: HPSchema,
  fuel: FuelSchema,
  vision: VisionSchema,
  armor: ArmorSchema,
  ...HasXYSchema.entries,
  ...HasMobilitySchema.entries,
  builtThisTurn: WasBuiltThisTurnSchema,
  // attackedThisTurn: AttackedThisTurnSchema,
  cargo: fallback(EntityIdListSchema, () => []),
})

export type TransportCopterEntity = InferOutput<typeof TransportCopterEntitySchema>

/**
 * Light utility helicopter designed for rapid troop transport and resupply operations.
 */
export const TransportCopterEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.TransportCopter,
  dname: 'Transport Copter',
  layer_id: EntityLayerId.Unit2,
  group_id: EntityTypeGroupId.Unit,
  price: 50,
  transports: [EntityTypeId.Infantry],
  // resupplies: true,
  entDefaults,
  fuelPerDay: 3,
  armor_type: ArmorTypeId.LightVehicle,
  cargoLimit: 1,
}

export function createTransportCopterEntity(
  id: number,
  x: number,
  y: number,
  player_id: number | null
): TransportCopterEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
    player_id,
    cargo: [],
  }
}
